import styled from 'styled-components';

export const ButtonContainer = styled.button``;

export const ButtonContainerV1 = styled(ButtonContainer)``;
